'use strict';

var tslib_es6 = require('./_chunks/tslib.es6-Cfi3-HmA.js');
var responseInterceptors_ApplicationVersionInvalidInterceptor = require('./responseInterceptors/ApplicationVersionInvalidInterceptor.js');
var responseInterceptors_UnauthenticatedResponseInterceptor = require('./responseInterceptors/UnauthenticatedResponseInterceptor.js');
var RequestServiceBase = require('./RequestServiceBase.js');
var HttpError = require('./HttpError.js');
var requestBuilder_buildRequestFormData = require('./requestBuilder/buildRequestFormData.js');
require('./requestBuilder/buildRequestHeader.js');
require('./requestBuilder/constants.js');
require('./responseInterceptors/ResponseInterceptorRequestService.js');
require('./requestBuilder/buildUrlFromTemplate.js');
require('qs');
require('./requestBuilder/buildRequestBody.js');

const processResponse = (response) => tslib_es6.__awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (response.status === 204) {
        return null;
    }
    if ((_a = response.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) {
        return response.json();
    }
    return response.text();
});
class RequestService extends RequestServiceBase.RequestServiceBase {
    request(method_1, templateUrl_1) {
        return tslib_es6.__awaiter(this, arguments, void 0, function* (method, templateUrl, options = {}) {
            var _a, _b;
            // This temporary patch is needed until all of the consumer apps update TypescriptGenerator to 9.4.8
            options.format = (_b = (_a = options.formDataFormat) !== null && _a !== void 0 ? _a : options.format) !== null && _b !== void 0 ? _b : 'JSON';
            const url = this.buildUrl(templateUrl, options);
            const data = this.normalizeData(options);
            const headers = this.getHeaders(options.format);
            const fetchRequest = fetch(url, {
                method,
                headers,
                body: data != null
                    ? options.format === 'FormData'
                        ? requestBuilder_buildRequestFormData.convertToFormData(data)
                        : JSON.stringify(data)
                    : undefined,
                signal: options.signal,
            }).then(normalizeHttpError);
            return processResponse(yield this.intercept(fetchRequest));
        });
    }
}
function normalizeHttpError(response) {
    return tslib_es6.__awaiter(this, void 0, void 0, function* () {
        var _a;
        if (response instanceof Error) {
            throw new HttpError.HttpError(response.message, -1, null);
        }
        if (response.ok) {
            return response;
        }
        if ((_a = response.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.includes('application/json')) {
            throw new HttpError.HttpError(response.statusText, response.status, yield response.json());
        }
        throw new HttpError.HttpError(response.statusText, response.status, yield response.text());
    });
}
function createRequestService(requestServiceOptions) {
    const requestService = new RequestService(requestServiceOptions);
    requestService.registerInterceptor(new responseInterceptors_UnauthenticatedResponseInterceptor.UnauthenticatedResponseInterceptor());
    requestService.registerInterceptor(new responseInterceptors_ApplicationVersionInvalidInterceptor.ApplicationVersionInvalidInterceptor());
    return requestService;
}

exports.RequestService = RequestService;
exports.createRequestService = createRequestService;
//# sourceMappingURL=RequestService.js.map
